import React, { useState, useEffect } from 'react';

// Custom styles for table header
const tableStyles = `
.price-table-orange thead tr {
  background: #ff8c00 !important;
  color: #fff !important;
}
.price-table-orange tbody tr:hover {
  background: #fff3e0;
}
`;

const MONTHS = [
  { code: '01', label: 'January' },
  { code: '02', label: 'February' },
  { code: '03', label: 'March' },
  { code: '04', label: 'April' },
  { code: '05', label: 'May' },
  { code: '06', label: 'June' },
  { code: '07', label: 'July' },
  { code: '08', label: 'August' },
  { code: '09', label: 'September' },
  { code: '10', label: 'October' },
  { code: '11', label: 'November' },
  { code: '12', label: 'December' },
];

// Add shared column width styles for Top 5 and Bottom 5 tables
const tableColumnStyles = {
  rank: { width: '60px', minWidth: '60px', maxWidth: '60px' },
  division: { width: '140px', minWidth: '120px', maxWidth: '180px' },
  district: { width: '140px', minWidth: '120px', maxWidth: '180px' },
  item: { width: '180px', minWidth: '120px', maxWidth: '220px' },
  price: { width: '120px', minWidth: '100px', maxWidth: '140px', textAlign: 'right' },
};

const PriceWagesCard = ({ summaryData, priceYear, setPriceYear, priceMonth, setPriceMonth, handleCardClick, fullWidth = false }) => {
  const summary = summaryData?.summaryResult || null;
  const top5 = summaryData?.topBottomResult?.filter(x => x.rank_type === 'TOP') || [];
  const bottom5 = summaryData?.topBottomResult?.filter(x => x.rank_type === 'BOTTOM') || [];
  const [priceYearOptions, setPriceYearOptions] = useState([]);

  useEffect(() => {
    const currentYear = new Date().getFullYear();
    const options = [];
    for (let y = 2018; y <= currentYear; y++) {
      options.push(y.toString());
    }
    setPriceYearOptions(options.reverse());
    // Only set initial year if not already set from parent
    if (!priceYear) {
      setPriceYear(currentYear.toString());
    }
  }, []);

  const cardStyle = {
    transition: 'all 0.3s ease',
    borderRadius: '12px',
    border: 'none',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    cursor: 'pointer',
    borderLeft: '4px solid #ff8c00'
  };

  const gradientText = {
    background: 'linear-gradient(135deg, #ff8c00 0%, #ff4500 100%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text'
  };

  const formatNumber = (num) => num !== undefined && num !== null ? Number(num).toLocaleString() : '0';
  // Indian currency formatting
  const formatCurrency = (num) => num !== undefined && num !== null ? `${Number(num).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : '0.00';

  return (
    <>
      {/* Inject custom table styles */}
      <style>{tableStyles}</style>
      <div className={fullWidth ? "col-12 mb-4" : "col-xl-6 col-lg-6 mb-4"}>
        <div className="card h-100" style={cardStyle}>
          <div className="card-body">
            <div className="d-flex align-items-center mb-3 justify-content-between">
              <div className="d-flex align-items-center">
                <div className="fs-1 me-3" style={{ animation: 'pulse 2s infinite' }}>💰</div>
                <div>
                  <h5 className="card-title mb-0" style={gradientText}>Price & Wages Indices</h5>
                  <p className="text-muted mb-0 small">Price Statistics</p>
                </div>
              </div>
              <div className="d-flex align-items-center gap-3">
                <div className="d-flex align-items-center gap-2">
                  <label htmlFor="price-year-select" className="form-label fw-bold mb-0" style={{ fontSize: '14px', whiteSpace: 'nowrap' }}>Year:</label>
                  <select
                    id="price-year-select"
                    className="form-select form-select-sm"
                    value={priceYear}
                    onChange={e => setPriceYear(e.target.value)}
                    style={{ width: '90px', fontSize: '14px', cursor: 'pointer' }}
                  >
                    {priceYearOptions.map(year => (
                      <option key={year} value={year}>{year}</option>
                    ))}
                  </select>
                </div>
                <div className="d-flex align-items-center gap-2">
                  <label htmlFor="price-month-select" className="form-label fw-bold mb-0" style={{ fontSize: '14px', whiteSpace: 'nowrap' }}>Month:</label>
                  <select
                    id="price-month-select"
                    className="form-select form-select-sm"
                    value={priceMonth}
                    onChange={e => setPriceMonth(e.target.value)}
                    style={{ width: '130px', fontSize: '14px', cursor: 'pointer' }}
                  >
                    {MONTHS.map(month => (
                      <option key={month.code} value={month.code}>{month.label}</option>
                    ))}
                  </select>
                </div>
              </div>
            </div>

            {/* Summary Stat Cards (only 5: Total Records, Total Price Sum, Avg Price, Min Price) */}
            {!summaryData ? (
              <div className="text-center" style={{ minHeight: 120, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                Loading price data...
              </div>
            ) : (
              <>
                {summary && (
                  <div className="row mb-3 d-flex justify-content-between">
                    <div className="col text-center">
                      <div className="fw-bold" style={{ color: '#20c997' }}>
                        {formatNumber(summary.total_divisions)}
                      </div>
                      <small className="text-muted">Total Division</small>
                    </div>
                    <div className="col text-center">
                      <div className="fw-bold" style={{ color: '#dc3545'}}>
                        {/* {formatCurrency(summary.total_districts)} */}
                        75
                      </div>
                      <small className="text-muted">Total District</small>
                    </div>
                    {/* <div className="col text-center">
                      <div className="fw-bold" style={{ color: '#007bff' }}>
                        {formatCurrency(summary.total_item_names)}
                      </div>
                      <small className="text-muted">Total Items</small>
                    </div>
                    <div className="col text-center">
                      <div className="fw-bold" style={{ color: '#fd7e14' }}>
                        {formatCurrency(summary.average_price)}
                      </div>
                      <small className="text-muted">Average Price</small>
                    </div> */}
                    {/* <div className="col text-center">
                      <div className="fw-bold" style={{ color: '#6f42c1' }}>
                        {formatCurrency(summary.min_price)}
                      </div>
                      <small className="text-muted">Min Price</small>
                    </div> */}
                  </div>
                )}

                {/* Top 5 and Bottom 5 Price Data (stacked vertically, ASICard style) */}
                <div>
                  <div className="mt-2">
                    <b>Top 5 Prices:</b>
                    <table className="table table-bordered table-sm mt-1 asi-table-fixed-cols">
                      <thead>
                        <tr>
                          <th style={tableColumnStyles.rank}>Rank</th>
                          <th style={tableColumnStyles.division}>Division</th>
                          <th style={tableColumnStyles.district}>District</th>
                          <th style={tableColumnStyles.item}>Item Name</th>
                          {/* <th style={tableColumnStyles.price}>Price in (₹)</th> */}
                        </tr>
                      </thead>
                      <tbody>
                        {top5.length === 0 ? (
                          <tr><td colSpan={5} className="text-center text-muted">No data</td></tr>
                        ) : top5.map((item, idx) => (
                          <tr key={item.ITEM_CODE + item.DISTRICT_CODE}>
                            <td style={tableColumnStyles.rank}>{idx + 1}</td>
                            <td style={tableColumnStyles.division}>{(item.DIVISION || item.DIVISION_NAME || item.division || '').replace(/\s+Div(?:i|s)?sion\s*$/i, '').trim()}</td>
                            <td style={tableColumnStyles.district}>{item.DISTRICT_NAME}</td>
                            <td style={tableColumnStyles.item}>{item.ITEM_NAME}</td>
                            {/* <td style={tableColumnStyles.price}>{formatCurrency(item.PRICE)}</td> */}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <div className="mt-2">
                    <b>Bottom 5 Prices:</b>
                    <table className="table table-bordered table-sm mt-1 asi-table-fixed-cols">
                      <thead>
                        <tr>
                          <th style={tableColumnStyles.rank}>Rank</th>
                          <th style={tableColumnStyles.division}>Division</th>
                          <th style={tableColumnStyles.district}>District</th>
                          <th style={tableColumnStyles.item}>Item Name</th>
                          {/* <th style={tableColumnStyles.price}>Price in (₹)</th> */}
                        </tr>
                      </thead>
                      <tbody>
                        {bottom5.length === 0 ? (
                          <tr><td colSpan={5} className="text-center text-muted">No data</td></tr>
                        ) : bottom5.map((item, idx) => (
                          <tr key={item.ITEM_CODE + item.DISTRICT_CODE}>
                            <td style={tableColumnStyles.rank}>{idx + 1}</td>
                            <td style={tableColumnStyles.division}>{(item.DIVISION || item.DIVISION_NAME || item.division || '').replace(/\s+Div(?:i|s)?sion\s*$/i, '').trim()}</td>
                            <td style={tableColumnStyles.district}>{item.DISTRICT_NAME}</td>
                            <td style={tableColumnStyles.item}>{item.ITEM_NAME}</td>
                            {/* <td style={tableColumnStyles.price}>{formatCurrency(item.PRICE)}</td> */}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default PriceWagesCard; 
